import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-more\"><defs><style type=\"text/css\"></style></defs><path d=\"M160 448a96 96 0 1 1 0 192 96 96 0 0 1 0-192zM512 448a96 96 0 1 1 0 192 96 96 0 0 1 0-192z m352 0a96 96 0 1 1 0 192 96 96 0 0 1 0-192z\" p-id=\"25692\" fill=\"#2b83fa\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol